<nz-spin [nzSpinning]="loading">
  <div class="dashboard-page" data-tour="dashboard-workspace">
    <section class="dashboard-summary" data-tour="dashboard-summary">
    <div data-tour="dashboard-overview">
    <!-- Page header / onboarding -->
    <div class="dashboard-header">
      <div class="dashboard-header-main">
        <div class="dashboard-title">
          <span nz-icon nzType="dashboard" class="dashboard-title-icon"></span>
          <div style="min-width:0;">
            <div class="dashboard-title-text">{{ 'DASHBOARD.TITLE' | translate }}</div>

            <div class="muted-small" *ngIf="lastLoadedAt">
              <span nz-icon nzType="clock-circle" class="inline-icon"></span>
              {{ 'DASHBOARD.LAST_REFRESH' | translate:{ date: formatDateTimeByLang(lastLoadedAt) } }}
            </div>
          </div>
        </div>

        <div class="dashboard-help-inline">
          <span nz-icon nzType="info-circle" class="inline-icon"></span>
          <div class="muted-small">
            <div class="help-title">{{ 'DASHBOARD.HOW_TO_USE_TITLE' | translate }}</div>
            <ul class="help-list">
              <li>{{ 'DASHBOARD.HOW_TO_USE_1' | translate }}</li>
              <li>{{ 'DASHBOARD.HOW_TO_USE_2' | translate }}</li>
              <li>{{ 'DASHBOARD.HOW_TO_USE_3' | translate }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Global Summary KPIs -->
    <div class="summary-row">
      <div class="tab-pane">
        <nz-row [nzGutter]="[16, 16]">
          <!-- Total scans -->
          <nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="6" [nzXl]="6" class="kpi-summary-col">
            <nz-card class="kpi-summary-card kpi-total" [nzBordered]="true">
              <nz-statistic
                [nzTitle]="'DASHBOARD.TOTAL_SCANS' | translate"
                [nzValue]="totalScans"
                [nzPrefix]="kpiTotalTpl">
              </nz-statistic>
            </nz-card>
          </nz-col>

          <!-- Unique visitors -->
          <nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="6" [nzXl]="6" class="kpi-summary-col">
            <nz-card class="kpi-summary-card kpi-unique" [nzBordered]="true">
              <nz-statistic
                [nzTitle]="'DASHBOARD.UNIQUE_VISITORS' | translate"
                [nzValue]="uniqueVisitors"
                [nzPrefix]="kpiUniqueTpl">
              </nz-statistic>
            </nz-card>
          </nz-col>

          <!-- Outdated -->
          <nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="6" [nzXl]="6" class="kpi-summary-col">
            <nz-card
              class="kpi-summary-card kpi-outdated kpi-clickable"
              [nzBordered]="true"
              role="button"
              tabindex="0"
              nz-tooltip
              [nzTooltipTitle]="'DASHBOARD.KPI_OUTDATED_TOOLTIP' | translate"
              (click)="showOutdatedProperties()"
              (keydown.enter)="showOutdatedProperties()"
              (keydown.space)="showOutdatedProperties(); $event.preventDefault()"
            >
              <nz-statistic
                [nzTitle]="'DASHBOARD.OUTDATED_COUNT' | translate"
                [nzValue]="outdatedCount"
                [nzPrefix]="kpiOutdatedTpl"
                [nzValueStyle]="{ color: '#fa8c16' }">
              </nz-statistic>
              <div class="kpi-action-hint">
                <span nz-icon nzType="filter" class="inline-icon"></span>
                {{ 'DASHBOARD.KPI_CLICK_TO_FILTER' | translate }}
              </div>
            </nz-card>
          </nz-col>

          <!-- Inactive -->
          <nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="6" [nzXl]="6" class="kpi-summary-col">
            <nz-card
              class="kpi-summary-card kpi-inactive kpi-clickable"
              [nzBordered]="true"
              role="button"
              tabindex="0"
              nz-tooltip
              [nzTooltipTitle]="'DASHBOARD.KPI_INACTIVE_TOOLTIP' | translate"
              (click)="showInactiveProperties()"
              (keydown.enter)="showInactiveProperties()"
              (keydown.space)="showInactiveProperties(); $event.preventDefault()"
            >
              <nz-statistic
                [nzTitle]="'DASHBOARD.INACTIVE_COUNT' | translate"
                [nzValue]="inactiveCount"
                [nzPrefix]="kpiInactiveTpl"
                [nzValueStyle]="{ color: '#ff4d4f' }">
              </nz-statistic>
              <div class="kpi-action-hint">
                <span nz-icon nzType="filter" class="inline-icon"></span>
                {{ 'DASHBOARD.KPI_CLICK_TO_FILTER' | translate }}
              </div>
            </nz-card>
          </nz-col>

          <!-- KPI icon templates -->
          <ng-template #kpiTotalTpl>
            <span nz-icon nzType="qrcode" class="kpi-icon"></span>
          </ng-template>

          <ng-template #kpiUniqueTpl>
            <span nz-icon nzType="team" class="kpi-icon"></span>
          </ng-template>

          <ng-template #kpiOutdatedTpl>
            <span nz-icon nzType="warning" class="kpi-icon"></span>
          </ng-template>

          <ng-template #kpiInactiveTpl>
            <span nz-icon nzType="stop" class="kpi-icon"></span>
          </ng-template>
        </nz-row>
      </div>
    </div>
    </div>
    </section>

    <!-- Tabs -->
    <ng-container *ngIf="stats.length > 0; else noStatsTpl">
      <nz-tabset
        class="dashboard-tabs"
        nzSize="large"
        [nzAnimated]="false"
        [(nzSelectedIndex)]="activeTabIndex"
        (nzSelectedIndexChange)="onTabChange($event)"
      >

        <!-- Tab title templates: icon + badge for affordance -->
        <ng-template #overviewTitleTpl>
          <span nz-icon nzType="dashboard"></span>
          <span class="tab-title-text">{{ 'DASHBOARD.TAB_OVERVIEW' | translate }}</span>
        </ng-template>

        <ng-template #notificationsTitleTpl>
          <span nz-icon nzType="notification"></span>
          <span class="tab-title-text">{{ 'DASHBOARD.TAB_NOTIFICATIONS' | translate }}</span>
          <nz-badge class="tab-badge" [nzCount]="totalPushSubscribeEvents" [nzOverflowCount]="999"></nz-badge>
        </ng-template>

        <ng-template #propertiesTitleTpl>
          <span nz-icon nzType="home"></span>
          <span class="tab-title-text">{{ 'DASHBOARD.TAB_PROPERTIES' | translate }}</span>
          <nz-badge class="tab-badge" [nzCount]="stats.length" [nzOverflowCount]="999"></nz-badge>
        </ng-template>

        <!-- 1) Insights -->
        <nz-tab [nzTitle]="overviewTitleTpl">
          <div class="tab-pane" data-tour="dashboard-analytics">
            <!-- Company Insights -->
            <nz-row [nzGutter]="[16, 16]">

              <!-- Heatmap -->
              <nz-col [nzSpan]="24">
                <nz-card
                  [nzTitle]="'DASHBOARD.HEATMAP_TITLE' | translate"
                  style="margin-bottom: 16px;"
                >
                  <div class="heatmap-help">
                    {{ 'DASHBOARD.HEATMAP_HELP' | translate }}
                  </div>

                  <ng-container *ngIf="companyHeatmap?.length; else noHeatmapTpl">
                    <div class="heatmap-wrapper">
                      <table class="heatmap-table">
                        <thead>
                        <tr>
                          <th class="heatmap-corner"></th>
                          <th class="heatmap-hour" *ngFor="let h of hours">
                            {{ (h < 10 ? '0' + h : h) }}:00
                          </th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr *ngFor="let dow of dows; let di = index">
                          <th class="heatmap-dow">{{ weekdayLabel(dow) }}</th>

                          <td
                            *ngFor="let h of hours"
                            class="heatmap-cell"
                            [ngStyle]="heatCellStyle(companyHeatmap[dow][h])"
                            nz-tooltip
                            [nzTooltipTitle]="heatCellTooltip(dow, h, companyHeatmap[dow][h])"
                          >
                        <span class="heatmap-cell-text" *ngIf="companyHeatmap[dow][h] > 0">
                          {{ companyHeatmap[dow][h] }}
                        </span>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </ng-container>

                  <ng-template #noHeatmapTpl>
                    <span class="text-muted">{{ 'DASHBOARD.NO_DATA' | translate }}</span>
                  </ng-template>
                </nz-card>
              </nz-col>

              <!-- Top clicked links -->
              <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="12" [nzXl]="12">
                <nz-card [nzTitle]="'DASHBOARD.TOP_LINKS_TITLE' | translate" style="margin-bottom: 16px;">
                  <nz-table
                    #topLinksTable
                    [nzData]="topLinks"
                    [nzSize]="'small'"
                    [nzBordered]="true"
                    [nzShowPagination]="true"
                    [nzPageSize]="5"
                    [nzShowSizeChanger]="true"
                    [nzPageSizeOptions]="[5,10,20]"
                    [nzPaginationPosition]="'bottom'"
                    [nzTableLayout]="'fixed'"
                    class="top-links-table"
                  >
                    <thead>
                    <tr>
                      <th [nzSortFn]="sortByLinkLabel" style="width: 60%;">
                        {{ 'DASHBOARD.TOP_LINKS_URL' | translate }}
                      </th>

                      <th [nzSortFn]="sortByLinkClicks" style="width: 90px;">
                        {{ 'DASHBOARD.CLICKS' | translate }}
                      </th>

                      <th [nzSortFn]="sortByLinkProperties" style="width: 240px;">
                        {{ 'DASHBOARD.PROPERTIES' | translate }}
                      </th>
                    </tr>
                    </thead>

                    <tbody>
                    <tr *ngFor="let row of topLinksTable.data">
                      <td>
                        <div style="font-weight: 600;">{{ row.label }}</div>
                        <div
                          class="muted-small url-ellipsis"
                          nz-tooltip
                          [nzTooltipTitle]="row.url"
                        >
                          {{ row.url }}
                        </div>
                      </td>
                      <td>{{ row.clicks }}</td>
                      <td>
      <span nz-tooltip [nzTooltipTitle]="propertiesTooltip(row.propertyCounts)">
        {{ propertiesInline(row.propertyCounts, 2) }}
      </span>
                      </td>
                    </tr>
                    </tbody>
                  </nz-table>

                  <div *ngIf="!topLinks.length" class="muted-small">
                    {{ 'DASHBOARD.NO_DATA' | translate }}
                  </div>
                </nz-card>
              </nz-col>

              <!-- Top contact actions -->
              <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="12" [nzXl]="12">
                <nz-card [nzTitle]="'DASHBOARD.TOP_CONTACTS_TITLE' | translate" style="margin-bottom: 16px;">
                  <nz-row [nzGutter]="16" style="margin-bottom: 8px;">
                    <nz-col [nzSpan]="contactSummary.whatsapp > 0 ? 6 : 8">
                      <nz-statistic [nzTitle]="'DASHBOARD.CONTACT_PHONE' | translate" [nzValue]="contactSummary.phone"></nz-statistic>
                    </nz-col>
                    <nz-col [nzSpan]="contactSummary.whatsapp > 0 ? 6 : 8">
                      <nz-statistic [nzTitle]="'DASHBOARD.CONTACT_EMAIL' | translate" [nzValue]="contactSummary.email"></nz-statistic>
                    </nz-col>
                    <nz-col *ngIf="contactSummary.whatsapp > 0" [nzSpan]="6">
                      <nz-statistic [nzTitle]="'DASHBOARD.CONTACT_WHATSAPP' | translate" [nzValue]="contactSummary.whatsapp"></nz-statistic>
                    </nz-col>
                    <nz-col [nzSpan]="contactSummary.whatsapp > 0 ? 6 : 8">
                      <nz-statistic [nzTitle]="'DASHBOARD.CONTACT_OTHER' | translate" [nzValue]="contactSummary.other"></nz-statistic>
                    </nz-col>
                  </nz-row>

                  <nz-divider></nz-divider>

                  <div class="insight-subtitle">{{ 'DASHBOARD.TOP_PHONES' | translate }}</div>
                  <nz-list [nzBordered]="true" [nzSize]="'small'">
                    <nz-list-item *ngFor="let p of contactSummary.topPhones">
                      <div style="display:flex; justify-content:space-between; width:100%; gap:12px;">
                        <div style="min-width:0;">
                          <div nz-tooltip [nzTooltipTitle]="p.properties.join('\n')" class="url-ellipsis" style="font-weight: 500;">
                            <span nz-icon [nzType]="p.kind === 'mobile' ? 'mobile' : 'phone'" style="margin-right: 6px;"></span>
                            {{ p.value }}
                          </div>

                          <div *ngIf="p.relatedTo || p.relatedName" class="muted-small">
                            {{ formatContactRelatedTo(p.relatedTo) }}
                            <ng-container *ngIf="p.relatedName"> — {{ p.relatedName }}</ng-container>
                          </div>
                        </div>

                        <strong>{{ p.count }}</strong>
                      </div>
                    </nz-list-item>
                    <div *ngIf="!contactSummary.topPhones.length" class="muted-small">
                      {{ 'DASHBOARD.NO_DATA' | translate }}
                    </div>
                  </nz-list>

                  <ng-container *ngIf="contactSummary.topWhatsApp.length">
                    <nz-divider></nz-divider>

                    <div class="insight-subtitle">{{ 'DASHBOARD.TOP_WHATSAPP' | translate }}</div>
                    <nz-list [nzBordered]="true" [nzSize]="'small'">
                      <nz-list-item *ngFor="let w of contactSummary.topWhatsApp">
                        <div style="display:flex; justify-content:space-between; width:100%; gap:12px;">
                          <div style="min-width:0;">
                            <div nz-tooltip [nzTooltipTitle]="w.properties.join('\n')" class="url-ellipsis" style="font-weight: 500;">
                              <span nz-icon nzType="message" style="margin-right: 6px;"></span>
                              {{ w.value }}
                            </div>

                            <div *ngIf="w.relatedTo || w.relatedName" class="muted-small">
                              {{ formatContactRelatedTo(w.relatedTo) }}
                              <ng-container *ngIf="w.relatedName"> — {{ w.relatedName }}</ng-container>
                            </div>
                          </div>

                          <strong>{{ w.count }}</strong>
                        </div>
                      </nz-list-item>
                    </nz-list>
                  </ng-container>

                  <nz-divider></nz-divider>

                  <div class="insight-subtitle">{{ 'DASHBOARD.TOP_EMAILS' | translate }}</div>
                  <nz-list [nzBordered]="true" [nzSize]="'small'">
                    <nz-list-item *ngFor="let e of contactSummary.topEmails">
                      <div style="display:flex; justify-content:space-between; width:100%; gap:12px;">
                        <div style="min-width:0;">
                          <div nz-tooltip [nzTooltipTitle]="e.properties.join('\n')" class="url-ellipsis" style="font-weight: 500;">
                            <span nz-icon nzType="mail" style="margin-right: 6px;"></span>
                            {{ e.value }}
                          </div>

                          <div *ngIf="e.relatedTo || e.relatedName" class="muted-small">
                            {{ formatContactRelatedTo(e.relatedTo) }}
                            <ng-container *ngIf="e.relatedName"> — {{ e.relatedName }}</ng-container>
                          </div>
                        </div>

                        <strong>{{ e.count }}</strong>
                      </div>
                    </nz-list-item>
                    <div *ngIf="!contactSummary.topEmails.length" class="muted-small">
                      {{ 'DASHBOARD.NO_DATA' | translate }}
                    </div>
                  </nz-list>
                </nz-card>
              </nz-col>

              <!-- Most viewed documents -->
              <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="12" [nzXl]="12">
                <nz-card [nzTitle]="'DASHBOARD.TOP_DOCUMENTS_TITLE' | translate" style="margin-bottom: 16px;">
                  <nz-table
                    #topDocsTable
                    [nzData]="topDocuments"
                    [nzSize]="'small'"
                    [nzBordered]="true"
                    [nzShowPagination]="true"
                    [nzPageSize]="5"
                    [nzShowSizeChanger]="true"
                    [nzPageSizeOptions]="[5,10,20]"
                    [nzPaginationPosition]="'bottom'"
                  >
                    <thead>
                    <tr>
                      <th [nzSortFn]="sortByDocName">{{ 'DASHBOARD.DOCUMENT' | translate }}</th>
                      <th [nzSortFn]="sortByDocViews" style="width: 90px;">{{ 'DASHBOARD.VIEWS' | translate }}</th>
                      <th [nzSortFn]="sortByDocProperties">{{ 'DASHBOARD.PROPERTIES' | translate }}</th>
                    </tr>
                    </thead>

                    <tbody>
                    <tr *ngFor="let row of topDocsTable.data">
                      <td>{{ row.fileName }}</td>
                      <td>{{ row.views }}</td>
                      <td>
      <span nz-tooltip [nzTooltipTitle]="propertiesTooltip(row.propertyCounts)">
        {{ propertiesInline(row.propertyCounts, 2) }}
      </span>
                      </td>
                    </tr>
                    </tbody>
                  </nz-table>

                  <div *ngIf="!topDocuments.length" class="muted-small">
                    {{ 'DASHBOARD.NO_DATA' | translate }}
                  </div>
                </nz-card>
              </nz-col>

              <!-- Announcement performance -->
              <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="12" [nzXl]="12">
                <nz-card [nzTitle]="'DASHBOARD.TOP_ANNOUNCEMENTS_TITLE' | translate" style="margin-bottom: 16px;">
                  <nz-table
                    #topAnnouncementsTable
                    [nzData]="topAnnouncements"
                    [nzSize]="'small'"
                    [nzBordered]="true"
                    [nzShowPagination]="true"
                    [nzPageSize]="5"
                    [nzShowSizeChanger]="true"
                    [nzPageSizeOptions]="[5,10,20]"
                    [nzPaginationPosition]="'bottom'"
                  >
                    <thead>
                    <tr>
                      <th [nzSortFn]="sortByAnnouncementTitle">{{ 'DASHBOARD.ANNOUNCEMENT' | translate }}</th>
                      <th [nzSortFn]="sortByAnnouncementViews" style="width: 90px;">{{ 'DASHBOARD.VIEWS' | translate }}</th>
                      <th [nzSortFn]="sortByAnnouncementProperties">{{ 'DASHBOARD.PROPERTIES' | translate }}</th>
                    </tr>
                    </thead>

                    <tbody>
                    <tr *ngFor="let row of topAnnouncementsTable.data">
                      <td>
                        <div style="font-weight: 600;">{{ row.title }}</div>
                        <div class="muted-small">ID: {{ row.announcementId }}</div>
                      </td>
                      <td>{{ row.views }}</td>
                      <td>
      <span nz-tooltip [nzTooltipTitle]="propertiesTooltip(row.propertyCounts)">
        {{ propertiesInline(row.propertyCounts, 2) }}
      </span>
                      </td>
                    </tr>
                    </tbody>
                  </nz-table>

                  <div *ngIf="!topAnnouncements.length" class="muted-small">
                    {{ 'DASHBOARD.NO_DATA' | translate }}
                  </div>
                </nz-card>
              </nz-col>

            </nz-row>
          </div>
        </nz-tab>

        <!-- 2) Notifications -->
        <nz-tab [nzTitle]="notificationsTitleTpl">

          <!-- Notifications (Push) KPIs -->
          <div class="summary-row">
            <div class="tab-pane">
              <nz-row [nzGutter]="[16, 16]">
                <!-- Total subscribers -->
                <nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="6" [nzXl]="6" class="kpi-summary-col">
                  <nz-card class="kpi-summary-card kpi-notif-subs" [nzBordered]="true">
                    <nz-statistic
                      [nzTitle]="'DASHBOARD.NOTIF_TOTAL_SUBSCRIBERS' | translate"
                      [nzValue]="totalPushSubscribers"
                      [nzPrefix]="subPrefixTpl">
                    </nz-statistic>

                    <div class="kpi-help">
                      {{ 'DASHBOARD.NOTIF_TOTAL_SUBSCRIBERS_HELP' | translate }}
                    </div>
                  </nz-card>
                </nz-col>

                <!-- Unsubscribes -->
                <nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="6" [nzXl]="6" class="kpi-summary-col">
                  <nz-card class="kpi-summary-card kpi-notif-unsubs" [nzBordered]="true">
                    <nz-statistic
                      [nzTitle]="'DASHBOARD.NOTIF_UNSUBSCRIBES' | translate"
                      [nzValue]="totalPushUnsubscribes"
                      [nzValueStyle]="{ color: '#ff4d4f' }"
                      [nzPrefix]="unsubPrefixTpl">
                    </nz-statistic>

                    <div class="kpi-help">
                      {{ 'DASHBOARD.NOTIF_UNSUBSCRIBES_HELP' | translate }}
                    </div>
                  </nz-card>
                </nz-col>

                <!-- Subscribe events -->
                <nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="6" [nzXl]="6" class="kpi-summary-col">
                  <nz-card class="kpi-summary-card kpi-notif-events" [nzBordered]="true">
                    <nz-statistic
                      [nzTitle]="'DASHBOARD.NOTIF_SUBSCRIBE_EVENTS' | translate"
                      [nzValue]="totalPushSubscribeEvents"
                      [nzPrefix]="eventsPrefixTpl">
                    </nz-statistic>

                    <div class="kpi-help">
                      {{ 'DASHBOARD.NOTIF_SUBSCRIBE_EVENTS_HELP' | translate }}
                    </div>
                  </nz-card>
                </nz-col>

                <!-- Opt-in rate -->
                <nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="6" [nzXl]="6" class="kpi-summary-col">
                  <nz-card class="kpi-summary-card kpi-notif-rate" [nzBordered]="true">
                    <nz-statistic
                      [nzTitle]="'DASHBOARD.NOTIF_OPTIN_RATE' | translate"
                      [nzValue]="pushOptInRate"
                      [nzSuffix]="'%'"
                      [nzPrefix]="ratePrefixTpl">
                    </nz-statistic>

                    <div class="kpi-help">
                      {{ 'DASHBOARD.NOTIF_OPTIN_RATE_HELP' | translate }}
                    </div>
                  </nz-card>
                </nz-col>
              </nz-row>
            </div>

            <!-- prefixes (icons) -->
            <ng-template #subPrefixTpl>
              <span nz-icon nzType="notification" style="margin-right: 6px;"></span>
            </ng-template>
            <ng-template #unsubPrefixTpl>
              <span nz-icon nzType="eye-invisible" style="margin-right: 6px;"></span>
            </ng-template>
            <ng-template #eventsPrefixTpl>
              <span nz-icon nzType="mobile" style="margin-right: 6px;"></span>
            </ng-template>
            <ng-template #ratePrefixTpl>
              <span nz-icon nzType="like" style="margin-right: 6px;"></span>
            </ng-template>
          </div>

          <div style="margin-top: 16px;">
            <!-- Properties with subscribers (all, paginated/search/sort) -->
            <nz-card [nzTitle]="'DASHBOARD.NOTIF_TOP_PROPERTIES' | translate">

              <div class="notif-toolbar">
                <nz-input-group [nzPrefix]="notifSearchIconTpl" [nzSuffix]="notifSearchClearTpl">
                  <input
                    nz-input
                    [(ngModel)]="notifSearch"
                    (ngModelChange)="onNotifSearchChange()"
                    [placeholder]="'DASHBOARD.NOTIF_SEARCH_PROPERTIES' | translate"
                    [attr.aria-label]="'DASHBOARD.NOTIF_SEARCH_PROPERTIES' | translate"
                  />
                </nz-input-group>

                <ng-template #notifSearchIconTpl>
                  <span nz-icon nzType="search"></span>
                </ng-template>

                <ng-template #notifSearchClearTpl>
                <span
                  *ngIf="notifSearch"
                  nz-icon
                  nzType="close-circle"
                  class="clear-search-icon"
                  role="button"
                  tabindex="0"
                  nz-tooltip
                  [nzTooltipTitle]="'DASHBOARD.CLEAR_SEARCH' | translate"
                  (click)="clearNotifSearch()"
                  (keydown.enter)="clearNotifSearch()"
                ></span>
                </ng-template>

                <div class="notif-meta muted-small">
                  <ng-container *ngIf="notifTotal > 0; else noneTpl">
                    {{ 'DASHBOARD.NOTIF_SHOWING_TOTAL' | translate:{ total: notifTotal } }}
                  </ng-container>
                  <ng-template #noneTpl>
                    {{ 'DASHBOARD.NOTIF_NONE_WITH_SUBSCRIBERS' | translate }}
                  </ng-template>
                </div>
              </div>

              <nz-table
                [nzData]="subscriberPropertiesPage"
                [nzLoading]="notifLoading"
                [nzFrontPagination]="false"
                [nzTotal]="notifTotal"
                [nzPageIndex]="notifPageIndex"
                [nzPageSize]="notifPageSize"
                [nzShowSizeChanger]="true"
                [nzPageSizeOptions]="[5,10,20,50,100]"
                [nzShowQuickJumper]="true"
                (nzQueryParams)="onNotifQueryParamsChange($event)"
                [nzBordered]="true"
              >
                <thead>
                <tr>
                  <th nzColumnKey="address" [nzSortFn]="true">
                    {{ 'DASHBOARD.PROPERTY' | translate }}
                  </th>
                  <th nzColumnKey="pushSubscribers" [nzSortFn]="true" style="width: 180px;">
                    {{ 'DASHBOARD.NOTIF_SUBSCRIBERS' | translate }}
                  </th>
                </tr>
                </thead>

                <tbody>
                <tr *ngFor="let item of subscriberPropertiesPage">
                  <td>
                    <span nz-icon nzType="home" style="margin-right: 8px;"></span>
                    {{ item.address }}
                  </td>
                  <td>
                    <nz-badge [nzCount]="item.pushSubscribers || 0" [nzOverflowCount]="999"></nz-badge>
                  </td>
                </tr>
                </tbody>
              </nz-table>

            </nz-card>
          </div>

        </nz-tab>

        <!-- 3) Properties -->
        <nz-tab [nzTitle]="propertiesTitleTpl">
          <div #propertiesAnchor></div>

          <div class="properties-filter-bar" *ngIf="propertiesFilter !== 'all'">
            <nz-tag nzColor="blue">
              {{ 'DASHBOARD.PROPERTIES_FILTERED_BY' | translate:{ filter: (propertiesFilter === 'outdated' ? ('DASHBOARD.OUTDATED' | translate) : ('DASHBOARD.INACTIVE' | translate)) } }}
            </nz-tag>

            <button
              nz-button
              nzSize="small"
              nz-tooltip
              [nzTooltipTitle]="'DASHBOARD.CLEAR_FILTER_HELP' | translate"
              (click)="clearPropertiesFilter()"
            >
              <span nz-icon nzType="close"></span>
              {{ 'DASHBOARD.CLEAR_FILTER' | translate }}
            </button>
          </div>

          <div class="properties-toolbar">
            <div class="properties-toolbar-left">
              <nz-input-group [nzPrefix]="propSearchIconTpl" [nzSuffix]="propSearchClearTpl">
                <input
                  nz-input
                  [(ngModel)]="propertySearch"
                  [placeholder]="'DASHBOARD.SEARCH_PROPERTIES' | translate"
                  [attr.aria-label]="'DASHBOARD.SEARCH_PROPERTIES' | translate"
                />
              </nz-input-group>

              <ng-template #propSearchIconTpl>
                <span nz-icon nzType="search"></span>
              </ng-template>

              <ng-template #propSearchClearTpl>
                <span
                  *ngIf="propertySearch"
                  nz-icon
                  nzType="close-circle"
                  class="clear-search-icon"
                  role="button"
                  tabindex="0"
                  nz-tooltip
                  [nzTooltipTitle]="'DASHBOARD.CLEAR_SEARCH' | translate"
                  (click)="clearPropertySearch()"
                  (keydown.enter)="clearPropertySearch()"
                ></span>
              </ng-template>

              <div class="status-legend">
                <span class="muted-small">{{ 'DASHBOARD.STATUS_LEGEND' | translate }}</span>

                <nz-tag nzColor="green" nz-tooltip [nzTooltipTitle]="'DASHBOARD.STATUS_HEALTHY_HELP' | translate">
                  <span nz-icon nzType="check-circle" class="status-icon"></span>
                  {{ 'DASHBOARD.HEALTHY' | translate }}
                </nz-tag>

                <nz-tag nzColor="orange" nz-tooltip [nzTooltipTitle]="'DASHBOARD.STATUS_OUTDATED_HELP' | translate">
                  <span nz-icon nzType="warning" class="status-icon"></span>
                  {{ 'DASHBOARD.OUTDATED' | translate }}
                </nz-tag>

                <nz-tag nzColor="geekblue" nz-tooltip [nzTooltipTitle]="'DASHBOARD.STATUS_INACTIVE_HELP' | translate">
                  <span nz-icon nzType="stop" class="status-icon"></span>
                  {{ 'DASHBOARD.INACTIVE' | translate }}
                </nz-tag>
              </div>
            </div>

            <button
              nz-button
              nzType="primary"
              nz-tooltip
              [nzTooltipTitle]="'DASHBOARD.EXPORT_STATS_HELP' | translate"
              (click)="exportStatsToCSV()"
            >
              <span nz-icon nzType="download"></span>
              {{ 'DASHBOARD.EXPORT_STATS' | translate }}
            </button>
          </div>

          <!-- Table for Properties -->
          <nz-table
            #basicTable
            [nzData]="filteredStats"
            [nzSize]="'middle'"
            [nzScroll]="{ x: '1000px', y: '500px' }"
            [nzBordered]="true"
            [nzPageSize]="5"
            [nzShowSizeChanger]="true"
            [nzShowQuickJumper]="true"
            [nzPaginationPosition]="'bottom'"
          >
            <thead>
            <tr>
              <th [nzSortFn]="sortByAddress">{{ 'DASHBOARD.PROPERTY' | translate }}</th>
              <th [nzSortFn]="sortByTotalScans">{{ 'DASHBOARD.TOTAL_SCANS' | translate }}</th>
              <th [nzSortFn]="sortByUniqueVisitors">{{ 'DASHBOARD.UNIQUE_VISITORS' | translate }}</th>
              <th [nzSortFn]="sortByPushSubscribers" style="width: 120px;">
                {{ 'DASHBOARD.TOTAL_SUBSCRIBERS' | translate }}
              </th>
              <th [nzSortFn]="sortByLastUpdated">{{ 'DASHBOARD.LAST_UPDATED' | translate }}</th>
              <th>{{ 'DASHBOARD.STATUS' | translate }}</th>
              <th>{{ 'DASHBOARD.ACTIONS' | translate }}</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let stat of basicTable.data">
              <td>
                <a
                  class="property-link"
                  (click)="goToPropertyListWithSearch(stat.address)"
                  nz-tooltip
                  [nzTooltipTitle]="'DASHBOARD.OPEN_PROPERTY_NEW_TAB_TOOLTIP' | translate"
                >
                  <span class="property-link-text">{{ stat.address }}</span>
                  <span nz-icon nzType="link" class="property-link-icon"></span>
                </a>
              </td>
              <td>{{ stat.totalScans }}</td>
              <td>{{ stat.uniqueVisitors }}</td>
              <td>{{ stat.pushSubscribers || 0 }}</td>
              <td>{{ formatDateByLang(stat.lastUpdate) }}</td>
              <td>
                <nz-tag [nzColor]="getStatusColor(stat.isOutdated, stat.isInactive)">
                  <span
                    nz-icon
                    class="status-icon"
                    [nzType]="stat.isOutdated ? 'warning' : stat.isInactive ? 'stop' : 'check-circle'"
                  ></span>
                  {{ stat.isOutdated ? ('DASHBOARD.OUTDATED' | translate) : stat.isInactive ? ('DASHBOARD.INACTIVE' | translate) : ('DASHBOARD.HEALTHY' | translate) }}
                </nz-tag>

                <br />
                <small class="text-muted">{{ getUpdateBadgeText(stat) }}</small>
                <br />
                <small class="text-muted">{{ getScanBadgeText(stat) }}</small>
              </td>
              <td>
                <ng-container *ngIf="stat.totalScans > 0; else noScansTpl">
                  <button
                    nz-button
                    nzType="default"
                    nzSize="small"
                    nz-tooltip
                    [nzTooltipTitle]="'DASHBOARD.VIEW_DETAILS' | translate"
                    (click)="openDetailsModal(stat)"
                  >
                    <span nz-icon nzType="file-search"></span>
                    <span class="action-text">{{ 'DASHBOARD.VIEW_DETAILS' | translate }}</span>
                  </button>
                </ng-container>
                <ng-template #noScansTpl>
                <span class="text-muted">
                  {{ 'DASHBOARD.NO_SCANS_YET' | translate }}
                </span>
                </ng-template>
              </td>
            </tr>
            </tbody>
          </nz-table>

          <!-- Modal templates (kept in this tab) -->
          <ng-template #detailTpl>
            <ng-container *ngIf="selectedLanguageChart">
              <p><strong>{{ 'DASHBOARD.LANGUAGE_BREAKDOWN' | translate }}</strong></p>
              <div style="position: relative; width:100%; height:200px;">
                <canvas baseChart
                        [data]="selectedLanguageChart.data"
                        [type]="'pie'"
                        [options]="selectedLanguageChart.options">
                </canvas>
              </div>
              <nz-divider></nz-divider>
            </ng-container>

            <p><strong>{{ 'DASHBOARD.SCAN_TRENDS' | translate }}</strong></p>
            <div style="position: relative; width:100%; height:200px;">
              <canvas baseChart
                      *ngIf="selectedTrendChart"
                      [data]="selectedTrendChart.data"
                      [type]="'line'"
                      [options]="selectedTrendChart.options">
              </canvas>
            </div>

            <ng-container *ngIf="interactionEntries(selectedStat?.interactions).length > 0">
              <nz-divider></nz-divider>
              <p><strong>{{ 'DASHBOARD.INTERACTION_TYPES' | translate }}</strong></p>
              <div style="max-height: 250px; overflow-y: auto;">
                <nz-list [nzBordered]="true" [nzSize]="'small'" [nzItemLayout]="'vertical'">
                  <nz-list-item *ngFor="let item of selectedStat.interactionsDetailed">
                    <nz-list-item-meta
                      [nzTitle]="translateInteractionType(item.type)"
                      [nzDescription]="formatInteractionDescription(item)">
                    </nz-list-item-meta>
                    <div style="font-size: 12px; color: gray;">
                      {{ formatDateByLang(item.timestamp) }}
                    </div>
                  </nz-list-item>
                </nz-list>
              </div>

              <nz-divider></nz-divider>

              <div style="position: relative; width:100%; height:200px;">
                <canvas baseChart
                        *ngIf="selectedInteractionChart"
                        [data]="selectedInteractionChart.data"
                        [type]="'pie'"
                        [options]="selectedInteractionChart.options">
                </canvas>
              </div>
            </ng-container>
          </ng-template>

          <nz-modal
            [nzVisible]="isModalVisible"
            [nzTitle]="selectedStat?.address"
            (nzOnCancel)="closeModal()"
            [nzContent]="detailTpl"
            [nzFooter]="null"
            [nzWidth]="700"
          >
          </nz-modal>

        </nz-tab>

      </nz-tabset>
    </ng-container>

    <ng-template #noStatsTpl>
      <div
        class="muted-small"
        [attr.data-tour]="!loading ? 'dashboard-analytics' : null"
        style="margin-top: 12px;"
      >
        {{ 'DASHBOARD.NO_DATA' | translate }}
      </div>
    </ng-template>
  </div>

</nz-spin>
